import PermissionType from './PermissionType';
import RoleType from './RoleType';

export default class Role {
    roleType: RoleType;

    permissions: PermissionType[] = [];

    constructor(_roleType: RoleType) {
      this.roleType = _roleType;
    }
}
